<template>
    <div class="container px-0">
        <div v-if="selected && selected.type === 'site_survey_inspection_report'" class="form-submission-card mb-4">
            <div class="form-submission-card-content">
                <div class="row mb-3">
                    <div class="col-12">
                        <h4 class="text-danger">Active Site Survey Inspection Categories</h4>
                    </div>
                </div>
                <div v-for="(inspection_category) in inspection_category_settings" :key="inspection_category.id" class="row mb-2">
                    <div class="col-10">{{ inspection_category.type}}</div>
                    <div class="col-2">

                        <div class="flex-table--header-content-item">
                        <label class="toggle ml-2">
                            <input type="checkbox" v-model="inspection_category.checked" v-on:click="toggleActiveCategory(inspection_category)">
                            <span class="toggle--slider"></span>
                        </label>
                    </div>
                    </div>
                </div>
            </div>
        </div>
        <template v-if="pre_selected">
            <div class="row">
                <div class="col-12 mb-4 d-flex justify-content-between">
                    <svg-image
                        :src="'/svg/' + resource_group + '/chevron-left.svg'"
                        :auto_hover="true"
                        :spaced="true"
                        v-on:click="select(null)"
                    >
                        <span class="my-auto">Forms</span>
                    </svg-image>

                    <div v-if="selected.type == 'initial_briefing'">
                        <a class="btn btn-positive px-5" @click="view_by_operatives = !view_by_operatives">
                            <span v-if="view_by_operatives === false">View by operatives </span>
                            <span v-else >View by submissions </span>
                        </a>
                    </div>
                </div>
                <template v-if="filtered_submissions.length > 0">
                    <div class="col-12" v-if="view_by_operatives && selected.type == 'initial_briefing'">
                        <initial-briefing-page
                            :job="job"
                            :initial_briefings="initial_briefing_submissions"
                            :show_url="initial_briefing_show_url"
                            :can_crud_jobs="can_crud_jobs">
                        </initial-briefing-page>
                    </div>
                    <div class="col-12" v-else>
                        <div v-if="submissions.length" class="flex-table">
                            <list-item
                                v-for="(submission, index) in filtered_submissions"
                                :key="submission.id"
                                @click="showSubmission(index)"
                            >
                                <template slot="title">
                                    <h6 class="text-dark mb-0">{{selected.name}}</h6>
                                    <h6 v-if="submission.type !== 'toolbox_talks'" v-bind:class="findSubmissionStatus(submission).class">{{findSubmissionStatus(submission).title_line_2}}</h6>
                                    <h6 v-else class="text-primary">{{submission.toolbox_talk_entry.toolbox_talk.name}}</h6>
                                    <h6>{{submission.submitted_formatted}}</h6>
                                </template>

                                <template slot="center">
                                    <div v-if="!submission.certificate" class="badge badge--sm badge--secondary">{{submission.user.full_name}}</div>
                                    <div v-else class="d-flex">
                                        <div class="badge badge--sm badge--primary mr-3">{{submission.certificate.user.full_name}}</div>
                                        <div class="badge badge--sm badge--secondary">{{submission.user.first_name}}</div>
                                    </div>
                                </template>
                            </list-item>
                        </div>
                        <div v-if="loading" class="col-12">
                            <loader></loader>
                        </div>
                        <div class="row mt-2 px-2" v-else-if="!last_page">
                            <div class="col-12 text-center">
                                <button class="btn btn-primary" v-on:click="nextPage">Load More</button>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="col-12">
                        <div class="row">
                            <div class="col-12">
                                <div class="flex-table text-center">
                                    <h5 class="m-4 mx-auto text-dark">No completed submissions</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </template>

        <div v-else class="flex-table">
            <job-form-library-form-list-item
                v-for="formInstance in filtered_forms"
                :key="`form:${formInstance.id}`"

                :form-instance="formInstance"
                :submission-url="url"
                :edit-url="edit_url"
                :toggle-url="toggle_url"

                @duplicate="() => cloneFormModal(formInstance)"
            />
		</div>
        <clone-form-modal
            ref="clone_modal"
            :clone_url="clone_url"
        />

        <show-signature-modal
            :signature="selected_signature"
            :user="selected_user"
            ref="signature_modal_user"
        />
    </div>
</template>

<style scoped>
a.btn {
    color: white;
    cursor: pointer;
}

a.btn:hover {
    color: white;
}
</style>

<script>
	import ListItem from "../ListComponent/ListItem";
	import InitialBriefingPage from "../pages/InitialBriefingPage.vue";
	import Loader from "../general_components/Loader";
	import Collapsable from "../ListComponent/Collapsable";
    import CloneFormModal from "../modals/CloneFormModal";
    import ShowSignatureModal from "../modals/ShowSignatureModal";
    import JobFormLibraryFormListItem from "./JobFormLibraryFormListItem";

    export default {
		name: "JobFormLibraryComponent",

        components: {
            CloneFormModal,
            Collapsable,
            Loader,
            ListItem,
            InitialBriefingPage,
            ShowSignatureModal,
            JobFormLibraryFormListItem
        },

        props: {
            edit_url:null,
            inspection_category_settings:null,
            url:null,
        	forms:null,
            load_url:null,
            search:null,
            show_submission_url:null,
            pre_selected:null,
            toggle_url: {
                type: String,
                required: true
            },
            site_survey_url:null,
            clone_url: {
            	type: String,
				required: true
			},

            initial_briefing_submissions:null,
            can_crud_jobs:null,
            initial_briefing_show_url:null
        },
        data(){
			return {
				selected: null,

				loading: false,
                reload: false,

                page: 1,
                last_page: false,

                inspection_category_set:[],

                filtered_forms: [],

                submissions: [],
				filtered_submissions: [],
                view_by_operatives:false,

                selected_signature: null,
                selected_user: null
            }
        },

        beforeMount(){
		    if (this.pre_selected){
		        for (let i = 0; i < this.forms.length; i++){
		            if (this.forms[i].id === this.pre_selected){
		                this.selected = this.forms[i];
		                this.load();
		                break;
                    }
                }
            }

            // this.inspection_category_set = this.inspection_category_settings
			this.filtered_forms = Object.assign([], this.forms);
		    this.filtered_forms.sort((a, b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1);
        },

        methods: {
            openSignature(user, signature){
                this.selected_user = user;
                this.selected_signature = signature;
                this.$refs.signature_modal_user.open();
            },

            toggleActiveCategory(inspection_category) {
                axios.patch(this.site_survey_url.replace('?', inspection_category.id), {
                is_active: !inspection_category.checked
            });
            },

            toggleEnabled(form, e){
                axios.patch(this.toggle_url.replace('?', form.id), {
                    active: e.target.checked
                });
            },

            cloneFormModal(form){
            	this.$refs.clone_modal.open(form);
			},

			load(){
				let _this = this;

				if (!_this.selected) return;

				if (_this.loading) {
					_this.reload = true;
					return;
                }

				_this.loading = true;

				axios.get(_this.load_url.replace('?', _this.selected.id) + '?page=' + _this.page)
                    .then(function (response){
                    	_this.loading = false;
                    	if (_this.reload){
                    		_this.reload = false;
                    		_this.load();
                        }
                    	if (!_this.selected) return;

                    	_this.last_page = response.data.last_page === response.data.current_page;
                    	_this.page = response.data.current_page;
                    	response.data.data.forEach(function (submission){
                    		_this.submissions.push(submission);
                        });
                    	_this.filtered_submissions = Object.assign([], _this.submissions);
                    })
                    .catch(function () {
						_this.loading = false;
						if (_this.reload){
							_this.reload = false;
							_this.load();
						}
					})
            },

            nextPage(){
			    if (this.last_page) return;
			    this.page ++;
			    this.load();
            },

            showSubmission(index){
				window.location.href = this.show_submission_url.replace('?', this.submissions[index].id) + '?back_url=' + this.url.replace('?', this.selected.id);
            },

            select(form){
			    if (!form){
                    window.location.href = this.url.replace('?', '');
                    return;
                }

                window.location.href = this.url.replace('?', form.id);
            },

            findSubmissionStatus(submission) {
                return submission.resolution ? submission.resolution.form_status : submission.form_status;
            }
        },

        watch: {
            search(val){
				if (this.selected){
					//@todo database query (search via axios)
				}
				else {
					//Search only by name of form
					let _forms = [];
					this.forms.forEach(function (form){
						if (form.name.toLowerCase().indexOf(val.toLowerCase()) !== -1)
							_forms.push(form);
					});
					this.filtered_forms = _forms;
				}
            }
        }
	}
</script>
